import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CButton from "../../components/CButton";
import CCheckbox from "../../components/CCheckbox";
import { getAnnexure, getCachedAnnexureBlob, signAnnexure } from "../../slices/contractSlice";

const Annexure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [agreeAnnexure, setAgreeAnnexure] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [displayMethod, setDisplayMethod] = useState('object'); // 'object', 'iframe', 'embed'
  const [annexurePdf, setAnnexurePdf] = useState(null); // Store blob locally
  const { annexurePdfStatus } = useSelector((state) => state.contract);

  useEffect(() => {
    dispatch(getAnnexure());
  }, [dispatch]);

  // Get the blob from cache when status changes
  useEffect(() => {
    if (annexurePdfStatus?.loaded) {
      const blob = getCachedAnnexureBlob();
      if (blob) {
        setAnnexurePdf(blob);
        console.log("📄 Annexure blob retrieved from cache:", blob);
      }
    }
  }, [annexurePdfStatus]);

  useEffect(() => {
    console.log("📄 annexurePdf from Redux:", annexurePdf);
    console.log("📄 Type of annexurePdf:", typeof annexurePdf);
    console.log("📄 annexurePdf instanceof Blob:", annexurePdf instanceof Blob);
    console.log("📄 annexurePdf size:", annexurePdf?.size);
    console.log("📄 annexurePdf type:", annexurePdf?.type);
    if (annexurePdf instanceof Blob) {
      console.log("✅ annexurePdf is a Blob with size:", annexurePdf.size, "and type:", annexurePdf.type);

      // Check if it's actually a PDF
      if (annexurePdf.type === 'application/pdf') {
        console.log("✅ Blob is a PDF");
      } else {
        console.log("⚠️ Blob is not a PDF, type is:", annexurePdf.type);
      }
    } else if (annexurePdf) {
      console.log("⛔ annexurePdf is not a Blob, it's:", annexurePdf);
      console.log("⛔ annexurePdf keys:", Object.keys(annexurePdf));
    } else {
      console.log("❌ annexurePdf is null/undefined");
    }
  }, [annexurePdf]);

  useEffect(() => {
    if (annexurePdf) {
      console.log("🔗 Creating object URL for PDF blob...");

      // Check if blob is valid
      if (annexurePdf.size === 0) {
        console.error("❌ PDF blob is empty!");
        toast.error("PDF file is empty");
        return;
      }

      // Check if it's a valid PDF by looking at first few bytes
      const reader = new FileReader();
      reader.onload = function (e) {
        const uint8Array = new Uint8Array(e.target.result);
        const header = String.fromCharCode.apply(null, uint8Array.slice(0, 4));
        console.log("📄 PDF header:", header);

        if (header === '%PDF') {
          console.log("✅ Valid PDF header detected");
        } else {
          console.log("⚠️ Invalid PDF header, might be corrupted or not a PDF");
        }
      };
      reader.readAsArrayBuffer(annexurePdf.slice(0, 4));

      try {
        const url = URL.createObjectURL(annexurePdf);
        console.log("✅ PDF URL created:", url);
        // Add parameter to disable PDF toolbar and controls
        const urlWithParams = `${url}#toolbar=0&navpanes=0&scrollbar=0`;
        console.log("🔗 PDF URL with parameters:", urlWithParams);
        setPdfUrl(urlWithParams);

        // Cleanup function
        return () => {
          console.log("🧹 Cleaning up PDF URL:", url);
          URL.revokeObjectURL(url);
        };
      } catch (error) {
        console.error("❌ Error creating PDF URL:", error);
        toast.error("Failed to create PDF URL");
      }
    } else {
      console.log("⚠️ No annexurePdf to create URL from");
      setPdfUrl(null);
    }
  }, [annexurePdf]);

  const handleAgreeAnnexure = () => {
    dispatch(signAnnexure({ isAnnexureAgree: agreeAnnexure })).then((res) => {
      if (!res.error) {
        localStorage.setItem("isAnnexureAgree", true);
        sessionStorage.setItem("isAnnexureAgree", true);
        navigate("/module");
      }
    });
  };

  return (
    <>
      <div className="main-content">
        {pdfUrl ? (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            </div>

            {/* Render different display methods */}
            {displayMethod === 'object' && (
              <div style={{ marginBottom: '10px' }}>
                <object
                  data={pdfUrl}
                  type="application/pdf"
                  width="100%"
                  height="700px"
                  style={{ border: "1px solid #ccc" }}
                  onLoad={() => console.log("✅ Object tag loaded successfully")}
                >
                  
                </object>
              </div>
            )}

          </div>
        ) : (
          <div>
            <p>Loading PDF...</p>
            <p>Annexure PDF status: {annexurePdf ? "Loaded" : "Not loaded"}</p>
            {annexurePdf && <p>Blob size: {annexurePdf.size} bytes</p>}
            </div>
        )}

        <div className="contract-footer">
          <CCheckbox
            label="I agree to terms of this annexure"
            onChange={(e) => setAgreeAnnexure(e.target.checked)}
          />
          <CButton
            className="btn-primary"
            disabled={!agreeAnnexure}
            onClick={handleAgreeAnnexure}
          >
            Continue
          </CButton>
        </div>
      </div>
    </>
  );
};

export default Annexure;